import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyName,
    taxAgencyId,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    organizationName,
    passport,
    phone,
    phone2,
    province,
    taxId2,
    ward,
    acreage,
    address2,
    address3,
    address4,
    bankNumber,
    businessAddress,
    career,
    checkbox10,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
    checkbox7,
    checkbox8,
    checkbox9,
    district2,
    province2,
    quantityUse,
    shopName,
    timeActivityFrom,
    timeActivityTo,
    ward2,
  },
} = checkout;

const initialValues = {
  [contract.name]: "",
  [contractDate.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",

  [acreage.name]: "",
  [address2.name]: "",
  [address3.name]: "",
  [address4.name]: "",
  [bankNumber.name]: "",
  [businessAddress.name]: "",
  [career.name]: "",
  [checkbox10.name]: false,
  [checkbox3.name]: false,
  [checkbox4.name]: false,
  [checkbox5.name]: false,
  [checkbox6.name]: false,
  [checkbox7.name]: false,
  [checkbox8.name]: false,
  [checkbox9.name]: false,
  [district2.name]: "",
  [province2.name]: "",
  [quantityUse.name]: "",
  [shopName.name]: "",
  [timeActivityFrom.name]: "",
  [timeActivityTo.name]: "",
  [ward2.name]: "",
  [address.name]: "",
  [authDocument.name]: "",
  [authDocumentDate.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [district.name]: "",
  [email.name]: "",
  [email2.name]: "",
  [fax.name]: "",
  [fax2.name]: "",
  [field01a.name]: "",
  [field01b.name]: "",
  [field01c.name]: "",
  [field01d.name]: "",
  [organizationName.name]: "",
  [phone.name]: "",
  [phone2.name]: "",
  [province.name]: "",
  [taxId2.name]: "",
  [ward.name]: "",
};

export default initialValues;
